import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

interface ListaTree {
  lista: any[]
  repetidos: Repetidos[] | null
}
interface Repetidos{
  valor: string
  lista: any[];
}
@Component({
    selector: 'app-tree',
    templateUrl: './app-tree.component.html',
    styleUrls: ['./app-tree.component.css'],
    standalone: false
})
export class AppTreeComponent implements OnInit, OnChanges {
  @Input() value: any[] = [];
  @Output() seleccion = new EventEmitter<number>();
  data: ListaTree = { lista: [], repetidos: null };
  mostrarLista: boolean[] = []


  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    const lista: any[] = changes.value.currentValue;
    const repetidos: any[] = [];
    const mapRepetidos:Map<string, any[]> = new Map();
    const sinRepetidos: any[] = [];

    lista.forEach(item => {
      const seRepite = lista.filter(value => value.partnumber === item.partnumber).length > 1;
      if (seRepite) {
        repetidos.push(item);
        mapRepetidos.set(item.partnumber, repetidos);
      } else {
        sinRepetidos.push(item);
      }
    });
    this.data = {
      lista: sinRepetidos,
      repetidos: mapRepetidos.size === 0 ? null : this.generarReptidos(mapRepetidos)
    }
    console.log("eventoc changes lista ", this.data)
  }

  ngOnInit() {
  }

  seleccionarProducto(idProducto: number) {
    console.log('sellecion producto', idProducto)
    this.seleccion.emit(idProducto);
  }

  collapse(event: MouseEvent, index: number){
    this.mostrarLista[index] = !this.mostrarLista[index];
    const target = event.currentTarget as HTMLElement;
    if(this.mostrarLista[index]){
      target.classList.toggle('collapsed');
    }else{
      target.classList.remove('collapsed');
    }
    event.stopPropagation();
  }

  private generarReptidos(valoresMap: Map<string, any[]>): Repetidos[]{
    const repetidos: Repetidos[] = [];
    for (let [clave, valor] of valoresMap.entries()) {
      console.log('Clave:', clave, ', Valor:', valor);
      repetidos.push({valor: clave, lista: valor});
    }

    return repetidos;
  }
}
